<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <Toast />
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
            >
              <p style="color: #09517a; font-size: 20px; font-weight: 800">
                {{ $t("schemes") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
            >
              <Button
                iconPos="right"
                :label="$t('add')"
                v-tooltip.bottom="$t('add')"
                icon="pi pi-plus"
                @click="openNew"
                size="small"
                style=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card" id="custom_card">
        <div class="grid p-fluid">
          <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText
                    format="text"
                    v-model="search_filter"
                    @input="search(1)"
                  >
                  </InputText>
                  <label>{{ $t("search_scheme") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="status_dropdownItem"
                    :options="status_dropdownItems"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="status">{{ $t("status") }}</label>
                </span>
              </div>
              <div class="field col-2 md:col-2">
                <Button
                  icon="pi pi-refresh"
                  v-tooltip.bottom="$t('refresh')"
                  @click="search(2)"
                  class="p-button-danger"
                  style=""
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="PerPageOptions"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <template #header>
            <div style="text-align: right; font-weight: bold">
              <span>{{ $t("total_schemes") }}:</span>{{ totalRecords }}
            </div>
          </template>
          <Column
            :header="$t('status')"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge
                  class="p-button-success"
                  :value="data.status"
                  severity="success"
                ></badge
              ></span>
              <span
                v-else-if="
                  data.status == 'InActive' || data.status == 'In Active'
                "
                ><badge
                  class="p-button-warning"
                  :value="data.status"
                  severity="warning"
                ></badge
              ></span>
              <span
                v-else-if="data.status == 'Delete' || data.status == 'Deleted'"
                ><badge
                  class="p-button-danger"
                  :value="data.status"
                  severity="danger"
                ></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column :header="$t('scheme_name')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.scheme_name }}
            </template>
          </Column>
          <Column :header="$t('scheme_name_mr')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.scheme_name_mr }}
            </template>
          </Column>
          <Column :header="$t('description')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.description }}
            </template>
          </Column>
          <Column :header="$t('start_date')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ dateFormatDMY(data.start_date) }}
            </template>
          </Column>
           <Column :header="$t('end_date')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ dateFormatDMY(data.end_date) }}
            </template>
          </Column>
          <Column :header="$t('eligibility')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.eligibility }}
            </template>
          </Column>
          <Column :header="$t('contact_info')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.contact_info }}
            </template>
          </Column>
          <Column :header="$t('action')" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button
                v-if="slotProps.data.status != 'Deleted'"
                icon="pi pi-pencil"
                title="$t('edit_client')"
                v-tooltip.bottom="$t('edit')"
                class="p-button-rounded p-button-success mr-2"
                @click="editProduct(slotProps.data)"
                style=""
              />
              <Button
                v-if="slotProps.data.status != 'Deleted'"
                icon="pi pi-trash"
                v-tooltip.bottom="$t('delete')"
                class="p-button-rounded p-button-danger mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
                style=""
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <Dialog
      v-model:visible="productDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '35vw' }"
      :header="$t('events')"
      :modal="true"
      position="top"
    >
      <div class="col-12">
        <div class="p-fluid formgrid grid" style="margin-top: 2%">
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.scheme_name"
              />
              <label for="name">{{ $t("scheme_name") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="scheme_name_mr"
                type="text"
                v-model="product.scheme_name_mr"
              />
              <label for="name">{{ $t("scheme_name_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="scheme_name_hi"
                type="text"
                v-model="product.scheme_name_hi"
              />
              <label for="name">{{ $t("scheme_name_hi") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Textarea
                rows="2"
                id="description"
                type="text"
                v-model="product.description"
              />
              <label for="name">{{ $t("description") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Textarea
                rows="2"
                id="description_mr"
                type="text"
                v-model="product.description_mr"
              />
              <label for="name">{{ $t("description_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Textarea
                rows="2"
                id="description_hi"
                type="text"
                v-model="product.description_hi"
              />
              <label for="name">{{ $t("description_hi") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <!-- <InputText id="ticket_title" type="date" v-model="product.event_date" /> -->
              <Calendar
                id="ticket_title"
                v-model="product.start_date"
                dateFormat="dd/mm/yy"
              />
              <label for="name">{{ $t("start_date") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <!-- <InputText id="ticket_title" type="date" v-model="product.event_date" /> -->
              <Calendar
                id="ticket_title"
                v-model="product.end_date"
                dateFormat="dd/mm/yy"
              />
              <label for="name">{{ $t("end_date") }}</label>
            </span>
          </div>
          
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Textarea
                id="eligibility"
                type="text"
                rows="5"
                v-model="product.eligibility"
              />
              <label for="name">{{ $t("eligibility") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <InputText
                id="contact_info"
                type="text"
                v-model="product.contact_info"
              />
              <label for="name">{{ $t("contact_info") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 3%">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="addeditstatus_dropdownItem"
                :options="status_dropdownItems"
                optionLabel="name"
                filter
              >
              </Dropdown>
              <label for="status">{{ $t("status") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-2" style="margin-top: 3%">
            <FileUpload
              ref="fileUploader"
              class="p-button-primary"
              mode="basic"
              name="model[]"
              :auto="true"
              :custom-upload="true"
              :choose-label="$t('attachment')"
              accept="application/pdf"
              @uploader="handleFileUpload($event)"
            />
          </div>
          <div class="field col-12 md:col-2" style="margin-top: 3%"></div>
          <div class="field col-12 md:col-2" style="margin-top: 3%" v-if="url!=''">
            <Button
              icon="pi pi-file-pdf"
              :title="$t('view_details')"
              v-tooltip.bottom="$t('view')"
              class="p-button-danger mr-2"
              @click="viewattach()"
              />
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('save')"
          @click="save_event"
          icon="pi pi-check"
          class="p-button-success"
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="deleteProductDialog"
      :style="{ width: '450px' }"
      :header="$t('Confirm')"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="product"
          >{{ $t("delete_msg") }}<b>{{ product.scheme_name }}</b
          >?</span
        >
      </div>
      <template #footer>
        <Button
          :label="$t('no')"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteProductDialog = false"
        />
        <Button
          :label="$t('yes')"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteevent"
        />
      </template>
    </Dialog>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      url:'',
      status_dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      status_dropdownItem: null,
      addeditstatus_dropdownItem: null,
      search_filter: "",
      user_key: "",
      page_no: 1,
      isLoading: false,
      PerPageOptions: [10, 50, 100],
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.user_key = localStorage.getItem("user_type");
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  watch: {
    currentLocale() {},
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    async date_time_prefix() 
        {
            // Get the current date and time
            const currentDateTime = new Date();
            // Format the date as YYYY_MM_DD
            const formattedDate = currentDateTime
                .toISOString()
                .split("T")[0]
                .replace(/-/g, "_");
            // Format the time as HH_mm_ss
            const formattedTime = currentDateTime
                .toTimeString()
                .split(" ")[0]
                .replace(/:/g, "_");
            // Construct the final string
            const resultString = `${formattedDate}_${formattedTime}`;
            return resultString;
        },
    viewattach()
    {
      window.open(this.url)
    },
    async handleFileUpload(event) 
        {
            var fileUp = event.files[0];
            var file = fileUp;

                if (file.type !== "application/pdf") {
                   
                    this.$refs.fileUploader.clear();
                    this.$toast.add({
                    severity: "error",
                    summary: this.$t("error"),
                    detail: this.$t("Only PDF files are allowed."),
                    life: 3000,
                    });
                    return false;

                   
                }

            this.file = file;
            var prfeix = await this.date_time_prefix();
            var filename = prfeix + "_" + file.name;
            this.file_data = {
                filePath: filename,
                contentType: file.type,
            };
            var promise = apis.upload_to_AWS(this.file_data);
            promise.then((response) => {
                axios
                .put(response.data.data, file, {
                    headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": file.type,
                    },
                })
                .then((response) => {
                    this.url =
                    "https://eticket-docs.s3.ap-south-1.amazonaws.com/" + filename;
                });
            });
        },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    async save_event() {
      if (!this.product.scheme_name) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_scheme_name"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.scheme_name_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_scheme_name_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.scheme_name_hi) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_scheme_name_hi"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.description) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_description"),
          life: 3000,
        });
        return false;
      }
       if (!this.product.description_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_description_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.description_hi) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_description_hi"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.eligibility) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_eligibility"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.start_date) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_start_date"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.end_date) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_end_date"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.contact_info) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_contact_info"),
          life: 3000,
        });
        return false;
      }
      if (!this.addeditstatus_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_status"),
          life: 3000,
        });
        return false;
      }
      var details = {};
      if (this.product._id) {
        details = {
           _id: this.product._id,
            "scheme_name": this.product.scheme_name,
            "scheme_name_mr": this.product.scheme_name_mr,
            "scheme_name_hi": this.product.scheme_name_hi,
            "description": this.product.description,
            "description_mr": this.product.description_mr,
            "description_hi": this.product.description_hi,
            "eligibility": this.product.eligibility,
            "start_date": this.product.start_date,
            "end_date": this.product.end_date,
            "contact_info": this.product.contact_info,
            "updated_by": localStorage.getItem("id"),
            "status": this.addeditstatus_dropdownItem?.value,
            "lang": this.$i18n.locale,
            "attachment" : this.url
        };
        var promise = apis.updateScheme(details);
      } else {
        details = {
            "scheme_name": this.product.scheme_name,
            "scheme_name_mr": this.product.scheme_name_mr,
            "scheme_name_hi": this.product.scheme_name_hi,
            "description": this.product.description,
            "description_mr": this.product.description_mr,
            "description_hi": this.product.description_hi,
            "eligibility": this.product.eligibility,
            "start_date": this.product.start_date,
            "end_date": this.product.end_date,
            "contact_info": this.product.contact_info,
            "created_by": localStorage.getItem("id"),
            "status": this.addeditstatus_dropdownItem?.value,
            "client_id": localStorage.getItem("client_id"),
            "lang": this.$i18n.locale,
            "attachment" : this.url
          
        };
        var promise = apis.createScheme(details);
      }
      this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.productDialog = false;
        this.get_list();
        this.get_count();
      });
    },
    convertToTime12Hour(isoString) {
      const date = new Date(isoString);
      let hours = date.getHours();
      let minutes = date.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return `${hours}:${minutes} ${ampm}`;
    },
    async search(count) {
      if (count == 2) {
        this.search_filter = "";
        this.status_dropdownItem = null;
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.name,
        search: this.search_filter,
        count: true,
        AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.listScheme(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        if (this.totalRecords > 100) {
          this.PerPageOptions.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: false,
        page_no: this.page_no,
        limit: this.limit,
        AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.listScheme(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.url = '';
      this.addeditstatus_dropdownItem = { name: "Active", value: "Active" };
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.url = this.product.attachment;
      this.addeditstatus_dropdownItem = null;
      if (this.product.status) {
        this.addeditstatus_dropdownItem = {
          name: this.product.status,
          value: this.product.status,
        };
      }
      if (this.product.start_date) {
        this.product.start_date = new Date(this.product.start_date);
      }
      if (this.product.end_date) {
        this.product.end_date = new Date(this.product.end_date);
      }
     
      this.productDialog = true;
    },
    convertToISOString(timeStr) {
      const [time, modifier] = timeStr.split(" ");
      let [hours, minutes] = time.split(":").map(Number);
      if (modifier.toUpperCase() === "PM" && hours !== 12) {
        hours += 12;
      }
      if (modifier.toUpperCase() === "AM" && hours === 12) {
        hours = 0;
      }
      const now = new Date();
      now.setHours(hours, minutes, 0, 0); // set HH:mm:00.000
      return new Date(now.toISOString());
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          updated_by: localStorage.getItem("id"),
          lang: this.$i18n.locale,
        };
        this.isLoadingModel = true;
        var promise = apis.deleteScheme(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.$toast.add({
              severity: "success", // success, info, warn, error
              summary: this.$t("success"),
              detail: responseapi.data.message,
              life: 3000, // Toast disappears after 3 seconds
            });
            this.deleteProductDialog = false;
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Video");
          }
        });
      }
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  